import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy Norwegian route — permanent redirect to the German path
export const Route = createFileRoute("/kort/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/kreditkarten/$slug", params, statusCode: 301 });
  },
});
